"use strict";

const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./GridCellRenderer");

class GridCellComponent extends EventEmitter {
    constructor(configOptions) {
        super();

        this.setMaxListeners(0);

        this._id = _.get(configOptions, "id", undefined);
        this._value = _.get(configOptions, "value", undefined);
        this._column = _.get(configOptions, "column");
        this._columnRendererComponent = _.get(configOptions, "columnRendererComponent");
        this._width = this._column.getWidth();
        this._entityColumn = _.get(configOptions, "entityColumn", false);
        this._entity = this._entityColumn === true ? _.get(configOptions, "entity") : undefined;
        this._context = _.get(configOptions, "context", undefined);
        this._path = _.get(configOptions, "path", undefined);
        this._shown = _.get(configOptions, "shown", true);
        this._offScreenLeft = _.get(configOptions, "offScreenLeft", false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._id = undefined;
            this._value = undefined;
            this._columnRendererComponent = undefined;
            this._width = undefined;
            this._entityColumn = undefined;
            this._shown = undefined;
            this._offScreenLeft = undefined;
        });
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _triggerCellAction(eventData) {
        this.emit("CellAction", eventData);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    getColumnRendererComponent() {
        return this._columnRendererComponent;
    }

    setId(newVal) {
        this._id = newVal;
        this.emit("ID", this._id);
        return this;
    }

    getId() {
        return this._id;
    }

    getWidth() {
        return this._width;
    }

    setWidth(newVal) {
        this._width = newVal;
        this.emit("Width", this._width);
        return this;
    }

    setValue(newVal) {
        this._value = newVal;
        this.emit("Value", this._value);
        return this;
    }

    getValue() {
        return this._value;
    }

    getEntityColumn() {
        return this._entityColumn;
    }

    getEntity() {
        return this._entity;
    }

    getContext() {
        return this._context;
    }

    getPath() {
        return this._path;
    }

    setShown(newVal) {
        this._shown = newVal;
        this.emit("Shown", this._shown);
        return true;
    }

    getShown() {
        return this._shown;
    }

    /**
     * Set by the parent row component to signify that the cell is scrolled out of the grid body on the left side
     * @param newVal {Boolean} - Boolean corresponding to the state of being scrolled off of the grid body to the left
     * @returns {boolean}
     */
    setOffScreenLeft(newVal) {
        this._offScreenLeft = newVal;
        return true;
    }

    getOffScreenLeft() {
        return this._left;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = GridCellComponent;
